import { useMemo } from 'react';
import type { Layer, Position } from '@deck.gl/core';
import { IconLayer } from '@deck.gl/layers';
import { useSearchedLocation } from '../useSearchedLocation';

type Location = {
  longitude: number;
  latitude: number;
};

type Icon = {
  url: string;
  width: number;
  height: number;
  anchorX?: number;
  anchorY?: number;
  mask?: boolean;
};

type UseSearchPinLayer = {
  searchPinLayer: Layer;
};

const useSearchPinLayer = (): UseSearchPinLayer => {
  const { searchedLocation } = useSearchedLocation();

  const data = useMemo((): Location[] => {
    return searchedLocation ? [searchedLocation] : [];
  }, [searchedLocation]);

  const searchPinLayer = new IconLayer<Location>({
    id: 'search-pin-layer',
    data: data,
    getPosition: (item: Location): Position => {
      return [item.longitude, item.latitude];
    },
    getIcon: (): Icon => {
      return {
        url: '/icons/pin_search.png',
        width: 250,
        height: 250,
        mask: false,
      };
    },
    getPixelOffset: [0, -20],
    getSize: 40,
    pickable: false,
    visible: true,
  });

  return { searchPinLayer };
};

export { useSearchPinLayer };
